import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {CooperationPage} from '../model/cooperation.model';
import {HttpClient} from '@angular/common/http';
import {MY_PARTNER_AGENTS_URL} from '../../api-config';

@Injectable({
  providedIn: 'root'
})
export class CooperationService {

  constructor(private httpClient: HttpClient) { }

  public getCooperationsByAgentId(agentId: string): Observable<CooperationPage> {
    return this.httpClient.get<CooperationPage>(MY_PARTNER_AGENTS_URL.replace('{officeAllocationId}', agentId));
  }
}
